import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const MyCourses = createAsyncThunk('lecture-courses', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-lecturer/my-courses`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyStudents = createAsyncThunk('lecture-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-lecturer/my-students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerProfile = createAsyncThunk('lecture-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-lecturer/profile`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerAccountDetails = createAsyncThunk(
  'lecturer-account-details',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-lecturer/account-details`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditProfile = createAsyncThunk('profile-edit', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-lecturer/profile-edit`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UpdateProfile = createAsyncThunk('profile-update', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dphs-lecturer/profile-update`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getLecturerAccountDetails = createAsyncThunk(
  'account-details',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-lecturer/account-details`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const exportExcelAtt = createAsyncThunk('export-att', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dphs-lecturer/export-att`, data, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Student Attendance.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const ImportExcelAttendance = createAsyncThunk(
  'import-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}dphs-lecturer/import-att`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const exportExcelScore = createAsyncThunk('export-score', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-lecturer/export-score/${id}`, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Student Score.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const ImportExcelScore = createAsyncThunk('import-score', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dphs-lecturer/import-score`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerNews = createAsyncThunk('lecturer-news', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-lecturer/my-news`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type lecturerPortalState = {
  errors: any
}

const initialState: lecturerPortalState = {
  errors: '',
}

export const lecturerPortalSlice = createSlice({
  name: 'lecturer-portal',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = lecturerPortalSlice.actions
export default lecturerPortalSlice.reducer
